import Input from './input';
import { SIZE, KIND } from './constants';

export default Input;
export { SIZE, KIND };
